import { GDFCustomDrawPenStyle } from '../../../gdf/type';
import { StyleFactory } from '../styling';

export const customLayers: StyleFactory = (baseId) => {
    return [
        {
            type: 'fill',
            id: baseId + '-fill',
            filter: ['all', ['==', ['geometry-type'], 'Polygon'], ['==', ['get', 'useFill'], true]],
            source: baseId,
            pickable: true,
            paint: {
                'fill-color': ['get', 'fillColor']
            }
        },
        {
            type: 'line',
            id: baseId + '-line-solid',
            filter: ['all', ['==', ['get', 'usePen'], true], ['==', ['get', 'penStyle'], GDFCustomDrawPenStyle.solid]],
            source: baseId,
            pickable: true,
            paint: {
                'line-color': ['get', 'penColor'],
                'line-width': ['get', 'penWidth']
            }
        },
        {
            type: 'line',
            id: baseId + '-line-dot',
            filter: ['all', ['==', ['get', 'usePen'], true], ['==', ['get', 'penStyle'], GDFCustomDrawPenStyle.dot]],
            source: baseId,
            pickable: true,
            paint: {
                'line-color': ['get', 'penColor'],
                'line-width': ['get', 'penWidth'],
                'line-dasharray': [1, 1]
            }
        },
        {
            type: 'line',
            id: baseId + '-line-dash',
            filter: ['all', ['==', ['get', 'usePen'], true], ['==', ['get', 'penStyle'], GDFCustomDrawPenStyle.dash]],
            source: baseId,
            pickable: true,
            paint: {
                'line-color': ['get', 'penColor'],
                'line-width': ['get', 'penWidth'],
                'line-dasharray': [2, 1]
            }
        },
        {
            type: 'line',
            id: baseId + '-line-dashdot',
            filter: ['all', ['==', ['get', 'usePen'], true], ['==', ['get', 'penStyle'], GDFCustomDrawPenStyle.dashdot]],
            source: baseId,
            paint: {
                'line-color': ['get', 'penColor'],
                'line-width': ['get', 'penWidth'],
                'line-dasharray': [2, 1, 1, 1]
            }
        },
        {
            type: 'line',
            id: baseId + '-line-dashdotdot',
            filter: ['all', ['==', ['get', 'usePen'], true], ['==', ['get', 'penStyle'], GDFCustomDrawPenStyle.dastdotdot]],
            source: baseId,
            pickable: true,
            paint: {
                'line-color': ['get', 'penColor'],
                'line-width': ['get', 'penWidth'],
                'line-dasharray': [2, 1, 1, 1, 1, 1]
            }
        },
        {
            type: 'symbol',
            minzoom: 2,
            id: baseId + '-labels',
            filter: ['==', ['get', 'type'], 'label'],
            source: baseId,
            layout: {
                'text-field': ['get', 'label'],
                'text-offset': [0, 0.5],
                'text-allow-overlap': true,
                'text-anchor': 'top',
                'text-font': ['Open Sans Regular'],
                'text-size': 10
            },
            paint: {
                'text-color': ['global-state', 'text-color']
            }
        }
    ];
};
